module.exports = __webpack_public_path__ + "static/media/HCMM040.2ee0b94d.jpg";